import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { buildOtpPayload } from "./authContract";

const API_URL = config.API_URL;

const login = (values) => {
  const action = API_URL + "login";
  if (values && values.token) {
    const token = values.token;
    return axios.post(action, {
      action: "login",
      token,
    });
  } else {
    const formData = new FormData();
    for (let value in values) {
      formData.append(value, values[value]);
    }
    formData.append('action',action)
    return axios.post(action, formData);
  }
};

const twofactorauthentications = (values) => {
  const formData = new FormData();
  for (const value of ["email", "password", "salon_id"]) {
    if (values && values[value] !== undefined && values[value] !== null) {
      formData.append(value, values[value]);
    }
  }
  const action = "beforelogin/twofactorlogin";
  return axios.post(API_URL + action, formData);
};

const verifyTwoFactor = (values) => {
  return axios.post(API_URL + "beforelogin/twofactorlogin/verify", buildOtpPayload(values));
};

const redeemAdminHandoff = (grant) => {
  return axios.post(
    API_URL + "admin/auth/handoff/redeem",
    { grant },
    { headers: { "Content-Type": "application/json" } },
  );
};

const salonselection = (values) => {
  const formData = new FormData();
  if (values && values.email !== undefined && values.email !== null) {
    formData.append("email", values.email);
  }
  const action = "beforelogin/salonoptions";
  return axios.post(API_URL + action, formData);
};

const logout = () => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  return axios.post(
    API_URL + "afterlogin/logout",
    {
      action: "logout",
      auth_key,
    },
    { headers: authHeader() },
  );
};

const getUser = (authenticate) => {
  const token = authenticate.token;
  const auth_key = authenticate.auth_key;
  const action = "afterlogin/user";
  const data = {
    action: action,
    auth_key,
  };
  return axios.post(API_URL + action, data, { headers: authHeader({ token: token }) });
};

const forgotpassowrdsubmit = (values) => {
  const action = "beforelogin/forgotpassword";
  return axios.post(API_URL + action, {
    action: "afterlogin/forgotpassword",
    email: values.email,
    salon_id : values && values.salon_id ? values.salon_id : "",
  });
};

const forgotPasswordSalonSelect = (values) => {
  const formData = new FormData();
  for (let value in values) {
      formData.append(value, values[value]);
  }
  const action = "beforelogin/forgotpasswordsalonoptions";
  return axios.post(API_URL + action, formData);
};

export const resetPasswordEndpoint = (apiUrl) => {
  const endpoint = new URL(apiUrl);
  endpoint.pathname = endpoint.pathname.replace(/\/api\/v1\/?$/, "").replace(/\/$/, "") + "/web/reset-password";
  endpoint.search = "";
  endpoint.hash = "";
  return endpoint.toString();
};

const resetPassword = ({ token, password, password_confirmation }) => {
  const endpoint = resetPasswordEndpoint(API_URL);
  return axios.post(endpoint, { token, password, password_confirmation });
};

const AuthService = {
  login,
  logout,
  getUser,
  forgotpassowrdsubmit,
  twofactorauthentications,
  verifyTwoFactor,
  redeemAdminHandoff,
  salonselection,
  forgotPasswordSalonSelect,
  resetPassword,
};
export default AuthService;
